import * as z from "zod";

import {
  referrerStatusSchema,
  referrerSummarySchema,
  referrerTypeSchema,
} from "./shared";

export const updateReferrer = {
  name: "updateReferrer" as const,
  input: z.object({
    referrerId: z.string(),
    /** All fields optional — only the supplied fields are updated. */
    name: z.string().min(1).max(200).optional(),
    profileImageUrl: z.string().url().nullable().optional(),
    status: referrerStatusSchema.optional(),
    referrerType: referrerTypeSchema.optional(),
  }),
  output: z.object({ referrer: referrerSummarySchema }),
};
